var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Precio Sugerido","storeName":"Suggested_prices","labelAddNew":"Suggested_prices","canAdd":false,"canEdit":true,"canDelete":false,"sortable":"","next-link":"/admin/prices/edit/general","breadcrumbs":[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/suggested_prices'
        },
        {
          text: 'Precio Sugerido',
          disabled: false,
          href: '#'
        },
        
      ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }